import React from 'react';
import { EditPanel, Tray } from '../../components/elements';
import { isSurveyTemplateElementGroupData } from '../../components/Surveys/isSurveyTemplateElementGroupData';
import { isSurveyTemplateUnitData } from '../../components/Surveys/isSurveyTemplateUnitData';
import { ISurveyTemplateElementGroupData } from '../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditVerificatieBerekeningAnalysisElementGroup } from './SurveyEditVerificatieBerekeningAnalysisElementGroup';
import { SurveyEditVerificatieBerekeningAnalysisUnit } from './SurveyEditVerificatieBerekeningAnalysisUnit';

export function SurveyEditVerificatieBerekeningAnalysis(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    if (!isSurveyTemplateUnitData(props) && !isSurveyTemplateElementGroupData(props)) {
        return <Tray>&nbsp;</Tray>;
    }
    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                {isSurveyTemplateUnitData(props) && (
                    <SurveyEditVerificatieBerekeningAnalysisUnit
                        unitId={props.unitId}
                        unitName={props.unitName}
                        surveyId={props.surveyId}
                        onItemChanged={props.onItemChanged}
                    />
                )}
                {isSurveyTemplateElementGroupData(props) && (
                    <SurveyEditVerificatieBerekeningAnalysisElementGroup
                        elementGroupName={props.elementGroupName}
                        surveyId={props.surveyId}
                        objectId={props.objectId}
                        onItemChanged={props.onItemChanged}
                    />
                )}
            </EditPanel>
        </Tray>
    );
}
